import React from "react";

const HeaderComponent = (props) => {
    const { title, text } = props
    return (
        <div className="frth-design-header-component-main">
            <h2>
                {title}
            </h2>
            <hr />
            <p>
                {text}
            </p>
        </div>
    )
}

export default HeaderComponent